// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__NnXVE","label":"styles_label__yI37n","caption":"styles_caption__nrXe2","description":"styles_description__EUCRS","content":"styles_content__oGDaN"};